/**
 * @flow
 * @relayHash 264584152ed3304327b76686cf19476f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type NofollowedPagesTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type NofollowedPagesTable_RefetchQueryVariables = {|
  host: string,
  limit?: ?number,
  offset?: ?number,
  nofollowTypeFilters?: ?$ReadOnlyArray<?string>,
  sourceUrl?: ?TextFilters,
  url?: ?TextFilters,
|};
export type NofollowedPagesTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: NofollowedPagesTable_project$ref
  |}
|};
export type NofollowedPagesTable_RefetchQuery = {|
  variables: NofollowedPagesTable_RefetchQueryVariables,
  response: NofollowedPagesTable_RefetchQueryResponse,
|};
*/


/*
query NofollowedPagesTable_RefetchQuery(
  $host: String!
  $limit: Int
  $offset: Int
  $nofollowTypeFilters: [String]
  $sourceUrl: TextFilters
  $url: TextFilters
) {
  project(host: $host) {
    ...NofollowedPagesTable_project_44ipVH
    id
  }
}

fragment NofollowedPagesTable_project_44ipVH on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countNofollowTypesNofollowedPages(url: $url, sourceUrl: $sourceUrl) {
          type
          count
        }
        nofollowedPages(offset: $offset, limit: $limit, url: $url, sourceUrl: $sourceUrl, nofollowTypeFilters: $nofollowTypeFilters) {
          count
          edges {
            node {
              ...NofollowedPagesRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment NofollowedPagesRow_issue on NofollowedPage {
  id
  type
  severity
  url
  source_url
  nofollow_types
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "nofollowTypeFilters",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "url",
    "type": "TextFilters",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "sourceUrl",
  "variableName": "sourceUrl",
  "type": "TextFilters"
},
v3 = {
  "kind": "Variable",
  "name": "url",
  "variableName": "url",
  "type": "TextFilters"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "NofollowedPagesTable_RefetchQuery",
  "id": null,
  "text": "query NofollowedPagesTable_RefetchQuery(\n  $host: String!\n  $limit: Int\n  $offset: Int\n  $nofollowTypeFilters: [String]\n  $sourceUrl: TextFilters\n  $url: TextFilters\n) {\n  project(host: $host) {\n    ...NofollowedPagesTable_project_44ipVH\n    id\n  }\n}\n\nfragment NofollowedPagesTable_project_44ipVH on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countNofollowTypesNofollowedPages(url: $url, sourceUrl: $sourceUrl) {\n          type\n          count\n        }\n        nofollowedPages(offset: $offset, limit: $limit, url: $url, sourceUrl: $sourceUrl, nofollowTypeFilters: $nofollowTypeFilters) {\n          count\n          edges {\n            node {\n              ...NofollowedPagesRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment NofollowedPagesRow_issue on NofollowedPage {\n  id\n  type\n  severity\n  url\n  source_url\n  nofollow_types\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "NofollowedPagesTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "NofollowedPagesTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "nofollowTypeFilters",
                "variableName": "nofollowTypeFilters",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "url",
                "variableName": "url",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "NofollowedPagesTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countNofollowTypesNofollowedPages",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v4,
                          v5
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "nofollowedPages",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "nofollowTypeFilters",
                            "variableName": "nofollowTypeFilters",
                            "type": "[String]"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          v2,
                          v3
                        ],
                        "concreteType": "NofollowedPageConnection",
                        "plural": false,
                        "selections": [
                          v5,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "NofollowedPageEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "NofollowedPage",
                                "plural": false,
                                "selections": [
                                  v6,
                                  v4,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "nofollow_types",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v6
                    ]
                  }
                ]
              }
            ]
          },
          v6
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b81faa99fe832b3fea29eefcfd351f46';
module.exports = node;
